import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Funcionario } from '../../api.service';
import { CameraFacialComponent, ModoCameraFacial } from '../../shared/camera-facial.component';
import { CaixaFaceDetectada } from '../../shared/servico-reconhecimento-facial';

@Component({
  selector: 'app-painel-face-funcionario',
  standalone: true,
  imports: [CommonModule, CameraFacialComponent],
  templateUrl: './painel-face-funcionario.component.html',
  styleUrls: ['./painel-face-funcionario.component.css']
})
export class PainelFaceFuncionarioComponent {
  @Input({ required: true }) funcionario!: Funcionario;
  @Input() statusFaceReferencia = 'nao capturada';
  @Input() cameraAtiva = false;
  @Input() cameraModo: ModoCameraFacial = 'cadastro';
  @Input() rostoDetectado = false;
  @Input() provaVidaOk = false;
  @Input() capturando = false;
  @Input() mensagemCamera = '';
  @Input() caixaFace?: CaixaFaceDetectada;
  @Input() limiteFacesReferencia = 4;

  @Output() validarFace = new EventEmitter<void>();
  @Output() capturarFace = new EventEmitter<void>();
  @Output() removerFace = new EventEmitter<string>();
  @Output() confirmarFace = new EventEmitter<void>();
  @Output() cancelarFace = new EventEmitter<void>();

  faceRemocaoPendente?: string;

  get facesAtivas() {
    return (this.funcionario.faces || []).filter(face => face.ativo);
  }

  get limiteFacesAtingido() {
    return this.facesAtivas.length >= this.limiteFacesReferencia;
  }

  get exibirImagemLegada() {
    return !this.funcionario.faces && !!this.funcionario.imagemFacialBase64 && !this.cameraAtiva;
  }

  solicitarRemocaoFace(faceId: string) {
    this.faceRemocaoPendente = faceId;
  }

  cancelarRemocaoFace() {
    this.faceRemocaoPendente = undefined;
  }

  confirmarRemocaoFace() {
    if (!this.faceRemocaoPendente) {
      return;
    }

    this.removerFace.emit(this.faceRemocaoPendente);
    this.faceRemocaoPendente = undefined;
  }
}
